import { z } from "zod";

export const GestaoResiduosSchema = z.object({
  idGestaoResiduos: z.number().nullable().optional(),
  idObra: z.number().nullable().optional(),
  classe: z.string().nullable().optional(),
  caracteristica: z.string().nullable().optional(),
  tipo: z.string().nullable().optional(),
  formaSegregacao: z.string().nullable().optional(),
  empresaGerenciadora: z.string().nullable().optional(),
  destinacaoFinal: z.string().nullable().optional(),
  arquivo: z.instanceof(File).nullable().optional(),
  nomeArquivo: z.string().nullable().optional(),
});

export type GestaoResiduosForm = z.infer<typeof GestaoResiduosSchema>;
